module.exports = __webpack_public_path__ + "img/yjb_home_logo@2x.09e229b0.png";